import React from 'react';
import { FIREBASE_STORAGE_PATH } from '../../../utils';
import { Helmet } from 'react-helmet';

export function BuilderSEO({ origin, location, title, description, children }) {
    const MS_ICON = `${FIREBASE_STORAGE_PATH}general%2Fseo%2Fms-icon-128x128.webp?alt=media&token=afede360-ac33-424d-9f9d-629a0d41d8ca`;
    const MILAN_OG_IMG = `${FIREBASE_STORAGE_PATH}general%2Fseo%2Fmilan-og-img.webp?alt=media&token=06d51ff2-c1bc-4d11-980a-d267a9f33a4a`;

    return (
        <Helmet>
            <html lang="en" />
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content="Laser hair removal, waxing, hair removal, shaving, razors" />
            <link rel="canonical" href={`${origin}${location.pathname}`} />

            <meta name="msapplication-TileColor" content="#F2FAFD" />
            <meta name="msapplication-TileImage" content={MS_ICON} />

            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:url" content={`${origin}${location.pathname}`} />
            <meta property="og:image" content={MILAN_OG_IMG} />

            <meta name="twitter:title" content={title} />
            <meta name="twitter:site" content="@MilanLaser" />
            <meta name="twitter:creator" content="@MilanLaser" />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={MILAN_OG_IMG} />
            <meta name="twitter:card" content="summary_large_image" />

            {children}
        </Helmet>
    );
}
export default BuilderSEO;
